import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const GoaPage = () => {
  return <DestinationTemplate destinationId="goa" />;
};

export default GoaPage;
